import React, { Fragment } from "react";
import "../Task/Task.css";

import { Container } from "reactstrap";

import heroImg from "../../assests/images/hero-img1.png";
import TaskCard from "../Task/TaskCard";
import Header from "../Header/Header";
import Navmenu from "../Navmenu/Navmenu";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../Footer/Footer";


const taskdata = [
    {
        task_id: "50",
        content_title: `Толық тоқ заңын (Эрстед заңын) қолданамыз және саңылау аймағын қоса есептегенде өзекшенің ішіндегі магнит өрісі біртекті деп есептейміз. Олай болатын болса, онда циркуляцияны  түрінде елестетуге болады: өзекшедегі және саңылау аймағындағы магнит өрісінің кернеулігі. 
        Тороид өзекшесіндегі индукция ауа саңылауындағы индукциямен бірдей 
        ( , олай болса    
        `,
        id_faq: "faq_50",
        for_faq: "faq_50",
        question: `Сақина түрінде бүктелген темір өзекшенің ұзындығы    және бойында N = 1000 орам бар. Сақинада ені    саңылау бар. I = 20 А тоқ шамасындағы ауа саңылауындағы магнит өрісінің индукциясы B =1,6 Тл. Осы жағдайлардағы темір өзекшенің магниттік    өтімділігін табыңыз.  `,
        img_url: heroImg,
        answers: `# Тогы бар тороид
        import math as mt
        mu0=4*mt.pi*1.0e-7;N=1000;I=20;l1=1;l2=0.01;B=1.6;
        mu=l1/(mu0*I*N/B-l2);
        print('mu=',mu)
        `,
        languages: "python",
        container_id: 50,
        img1: `Снимок экрана (1140).png`,
        img2: ``,
    },
    {
        task_id: "51",
        content_title: `Мұндағы   , ал 


        Онда стерженнің 0-1 бөлігінде потенциалдар айырымы 
           өрнегіне тең. 
        Стерженнің екінші 0-2 бөлігі үшін:   өрнегіне тең.
        Стерженнің 1-2 бөлігіндегі яғни шеткі нүктелерінің арасындағы потенциалдар айырымы:
        `,
        id_faq: "faq_51",
        for_faq: "faq_51",
        question: `Магнит өрісінде стерженді айналысқа келтіретін болсақ, онда электрондарға Лоренц күші әсер етеді және стерженнің шеткі нүктелерінде потенциалдар айырымы пайда болады. 0 және 1 нүктелерінің арасындағы ЭҚК-нің индукциясы`,
        img_url: heroImg,
        answers: `# Айналыстағы стерженнің ЭҚК-інің индукциясы 1
        import math as mt
        l0=1.2; l1=0.95; B=0.001; v=2;
        omega=2*mt.pi*v; l2=l0-l1; Dp=-B*(l1*l1-l2*l2)*omega/2;
        print('Dp=',Dp)
        `,
        languages: "python",
        container_id: 51,
        img1: `Снимок экрана (1141).png`,
        img2: ``,
    },
    {
        task_id: "52",
        content_title: `Рамкадағы электромагниттік индукция (ЭҚК) электр қозғаушы күші (Фарадей заңы)      өрнегімен анықталады. Орам арқылы өтетін толық магнит ағыны   


        Максималь ЭҚК –нің       индукциясы:  
        `,
        id_faq: "faq_52",
        for_faq: "faq_52",
        question: `Ауданы  S = 50 см2,   N = 500  орамы бар  рамка   жиілікпен, 
        индукциясы B = 0,35 Тл болатын, магнит өрісінде бірқалыпты айналыс жасайды.  Айналыс осі рамка жазықтығында орналасқан және индукция сызықтарына перпендикуляр. Рамкада пайда болатын максималь ЭҚК –нің       индукциясын     анықтаңыз.
        `,
        img_url: heroImg,
        answers: `# Айналыстағы стерженнің ЭҚК-інің индукциясы 2
        import math as mt
        N=500; S=5.0e-3; B=0.35; v=8;
        omega=2*mt.pi*v;Em=omega*B*N*S;
        print('Em=',Em)
        `,
        languages: "python",
        container_id: 52,
        img1: `Снимок экрана (1143).png`,
        img2: ``,
    },
    {
        task_id: "53",
        content_title: `Орамның кедергісін ескермесек, онда тізбектің толық кедергісі гальванометрдің кедергісімен анықталады. dt уақыт аралығындағы dФ  магнит ағынының өзгерісі   өрнегімен анықталады, ал ЭҚК – нің индукциясы    тең, сондықтан .
        Тоқ күші  өрнегімен анықталатындықтан, , немесе 
        Есептеу программасын құрастырайық:
        `,
        id_faq: "faq_53",
        for_faq: "faq_53",
        question: `Баллистикалық гальванометрге тіркелген сым сақинаға түзу магнит орнатқан. Тізбек бойымен Q = 10 мкКл заряд мөлшері ағып өтеді. Егер гальванометр тізбегінің кедергісі  болса, онда сақинаны қиып өтетін магнит ағыны неге тең болады?`,
        img_url: heroImg,
        answers: `# Сақина арқылы өтетін магнит ағыны
        Q=1.0e-5; R=30;
        Phi=R*Q;
        print('Phi=',Phi)
        `,
        languages: "python",
        container_id: 53,
        img1: `Снимок экрана (1142).png`,
        img2: ``,
    },
    {
        task_id: "54",
        content_title: `Катушканың индуктивтілігі  . Катушка арқылы ағып өтетін тоқ күшінің жиілігі  және ол синусойдалық заңдылық бойынша өзгереді. `,
        id_faq: "faq_54",
        for_faq: "faq_54",
        question: `Катушканың индуктивтілігі  . Катушка арқылы ағып өтетін тоқ күшінің жиілігі  және ол синусойдалық заңдылық бойынша өзгереді. `,
        img_url: heroImg,
        answers: `# Электромагнит арқылы орташа ЭҚК 4
        L=2.0e-3; Im=10; nu=50;
        E=4*nu*L*Im;
        print('E=',E)
        `,
        languages: "python",
        container_id: 54,
        img1: `Снимок экрана (1144).png`,
        img2: ``,
    },
    {
        task_id: "55",
        content_title: `d = 120 мм цилиндрлік каркасқа N = 100 орамды сымды бір қабат қылып ораған. Барлық бір қабат орам l = 60 мм ұзындыққа сиғызып оралған. Осындай катушканың  индуктивтілігін анықтаңыз. Катушка өзекшесінің магниттік өтімділігін бірге тең ().
        Ұзындығы белгілі катушканың индуктивтілігікелесі өрнекпен анықталады:
        
        
        
        
         мұндағы соленоидтың ұзындық бірлігіне келетін орам саны.     S - катушканың көлденең қимасының ауданы.
        
        
        
        Есептеу программасын құрастырайық:
        `,
        id_faq: "faq_55",
        for_faq: "faq_55",
        question: `d = 120 мм цилиндрлік каркасқа N = 100 орамды сымды бір қабат қылып ораған. Барлық бір қабат орам l = 60 мм ұзындыққа сиғызып оралған. Осындай катушканың  индуктивтілігін анықтаңыз. Катушка өзекшесінің магниттік өтімділігін бірге тең ().
        Ұзындығы белгілі катушканың индуктивтілігікелесі өрнекпен анықталады:
        `,
        img_url: heroImg,
        answers: `# Катушканың индуктивтілігі 5
        import math as mt
        mu0=4*mt.pi*1.0e-7; d=0.12; l=0.06; N=100;
        alp=1/(1+0.45*d/l);V=mt.pi*d*d*l/4; n=N/l;
        L0=n*n*mu0*V; LN=alp*L0;
        print('L0=',L0,' LN',LN)
        `,
        languages: "python",
        container_id: 55,
        img1: `Снимок экрана (1174).png`,
        img2: ``,
    },
    {
        task_id: "56",
        content_title: `Кирхгофтың екінші ережесі бойынша 
        (1)
   Тізбектелген тізбекте                   
   Тоқ күші мен кернеудің арасындағы байланысты келесі түрде жазуға болады:
      (2)
   онда  (1) – ші теңдеуді келесі түрде жазамыз    
   немесе             (3)
     - параметрін енгіземіз, мұндағы    - уақыт релаксациясы деп аталады. 
   Егер     деп белгілеп,  (3) –ші өрнекті қарапайым бірінші дәрежелі дифференциальдық теңдеуге келтірейік, сонда 
         (4)
   (4) – ші теңдеудің шешімін   түрінде көрсетелік немесе 
      (5)
    болғандықтан, 
   Тізбектегі тоқ күші       (6)
   (5)   және  (6)  өрнектер – уақытқа байланысты ізделініп отырған шамалар.
   `,
        id_faq: "faq_56",
        for_faq: "faq_56",
        question: `Сыйымдылығы С = 0.47 мкФ конденсатор t = 0 уақыт мезетінде R = 1.0 Ом  кедергіге және кернеуі   генераторға тізбектей жалғанған.  уақыт мезетіндегі  және    - ді анықтаңыз.`,
        img_url: heroImg,
        answers: `# RC тізбектегі ток релаксациясы 
        import math as mt
        import matplotlib.pyplot as plt
        C=0.47e-6; R=1.0; E=12.0; t1=1.e-6;
        tau=R*C; alpha=1./tau;
        U1=E*(1.-mt.exp(-alpha*t1));
        I1=E*mt.exp(-alpha*t1)/R;
        print('U1=',U1,'\nI1=',I1,'\ntau',tau,'\nt1/tau',t1/tau)
        NT=500; tmin=0; tmax=3.*tau; dt=(tmax-tmin)/NT;
        t=[]; U=[]; I=[];
        t.append(tmin/tau);U.append(E);I.append(E/R);
        for i in range(1,NT):
            tt=tmin+i*dt; t.append(tt/tau);
            U.append(E*(1.-mt.exp(-alpha*tt)));
            I.append(E*mt.exp(-alpha*tt)/R);
        plt.subplot(1,2,1)
        plt.plot(t,U,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t$',fontsize=16)
        plt.ylabel('$U_C$',fontsize=16)
        plt.subplot(1,2,2)
        plt.plot(t,I,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t$',fontsize=16)
        plt.ylabel('$I$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 56,
        img1: `56-мысал.gif`,
        img2: `Снимок экрана (1175).png`,
    },
    {
        task_id: "57",
        content_title: `Кирхгоф ережесіне сәйкес теңдеулер жүйесін құрастырамыз:


        Мұндағы I  -  арқылы өтетін тоқ күші,  -  арқылы өтетін тоқ күші, 
         – С арқылы өтетін тоқ күші. Соңғы теңдеулер жүйесінен   , екінші теңдеуден  . 
          өрнегіне сәйкес  сызба –нұсқадан  болатынын анықтауға болады. Тоқ күші үшін  алынған өрнектерді теңдеулер жүйесіндегі бірінші теңдеуге апарып қоямыз:
        
        немесе
        
        
        
          параметрін және айнымалысын 
        енгізе отырып, соңғы өрнекті қарапайым бірінші дәрежелі кәдімгі дифференциальдық теңдеуге келтіруге болады. Осы соңғы теңдеудің шешімін    немесе 
        
        
         болғандықтан  соңғы теңдеуді келесі түрге келтіруге болады:
        
        
        ал конденсатор астарларындағы заряд келесі өрнекпен анықталады`,
        id_faq: "faq_57",
        for_faq: "faq_57",
        question: `39-суретте келтірілген K кілтін  t = 0  уақыт мезетінде сызбаны тұйықтаған кездегі  С конденсатор астарларындағы зарядтың  уақытқа q(t) тәуелділігін анықтаңыздар. 
        уақыт мезетіндегі q зарядты және  UC  кернеуді табыңыздар. 
         деп қабылдаңыздар.
       `,
        img_url: heroImg,
        answers: `#R1R2C-тізбегіндегі ток күшінің релаксациясы
        import math as mt
        import matplotlib.pyplot as plt
        C=0.47e-6; R1=1.0; R2=1.0; E=1.5; t1=1.e-6;
        alpha=(R1+R2)/(R1*R2*C); tau=1./alpha;
        U1=E*R1*(1.-mt.exp(-alpha*t1))/(R1+R2);
        q1=E*R1*C*(1.-mt.exp(-alpha*t1))/(R1+R2);
        print('U1=',U1,'\nq1=',q1,'\ntau=',tau,'\nt1/tau=',t1/tau)
        NT=500; tmin=0; tmax=5.*tau; dt=(tmax-tmin)/NT;
        t=[]; U=[]; q=[];
        t.append(tmin/tau);U.append(0.);q.append(0.);
        for i in range(1,NT):
            tt=tmin+i*dt; t.append(tt/tau);
            U.append(E*R1*(1.-mt.exp(-alpha*tt))/(R1+R2));
            q.append(E*R1*C*(1.-mt.exp(-alpha*tt))/(R1+R2));
        plt.subplot(1,2,1)
        plt.plot(t,U,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t/tau$',fontsize=16)
        plt.ylabel('$U_C$',fontsize=16)
        plt.subplot(1,2,2)
        plt.plot(t,q,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t/tau$',fontsize=16)
        plt.ylabel('$q$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 57,
        img1: `57-мысал.gif`,
        img2: `Снимок экрана (1178).png`,
    },
    {
        task_id: "58",
        content_title: `Кирхгофтың екінші ережесі бойынша теңдеуді құрамыз:

        (1)

Тізбектелген тізбекте , сондықтан (1) теңдеуді келесі түрде жазуға болады:


немесе 
(2)

R/L = α  және     белгілеулерді енгізу арқылы (2) – теңдеуді қарапайым кәдімгі бірінші дәрежелі дифферециалдық теңдеу түріне алып келеміз. (2) – теңдеудің шешімін  түрінде береміз, сонда

(3)

болғандықтан, (3) –теңдеу келесі түрге ауысады:

          (4)

және кедергідегі кернеу келесі өрнекке тең болады`,
        id_faq: "faq_58",
        for_faq: "faq_58",
        question: `Кернеу генераторы  және индуктивтілігі L = 0.25 мГн катушка, R = 5.0 Ом кедергі бірі бірімен тізбектеп жалғанған. Егер генератордың кернеуі   және  t =0 уақыт мезетінде генератор қосылған болса, онда  уақыт мезетінде кедергідегі кернеуді анықтаңыз. `,
        img_url: heroImg,
        answers: `#RL-тізбегіндегі ток күшінің релаксациясы
        import math as mt
        L=0.25e-3; R=5.0;E=12; t1=1.e-6;
        alpha=R/L; tau=1./alpha;
        I1=E*(1.-mt.exp(-alpha*t1))/R;
        U1=E*(1.-mt.exp(-alpha*t1));
        print('U1=',U1,'\nI1=',I1,'\ntau=',tau,'\nt1/tau=',t1/tau)
        `,
        languages: "python",
        container_id: 58,
        img1: `Снимок экрана (1181).png`,
        img2: ``,
    },
    {
        task_id: "59",
        content_title: `Тағайындалған режімде, Кирхгофтың бірінші ережесіне сәйкес қортынды тоқ күші                 .                   (1)
        Мұндағы    – тұрақты тоқ күштері. Тоқ көзінен ажыратылғаннан кейін  (I = 0), тізбекте өздік индукция электр қозғаушы күші пайда болады және контур бойымен экстратоқ күші жүре бастайды. Оны анықтау үшін Кирхгофтың екінші ережесін қолданамыз:
        
                     (2)
        
        Қортынды тоқ күші нольге тең болғандықтан,  (1) –ші теңдеуден  екенін аламыз және (2) –ші теңдеуді келесі түрде жазуға болады:
                    (3)
        
        Бұл теңдеудің шешімі            (4)   түріне ие болады. 
        
        Мұндағы          . 
        
        Өздік индукция электр қозғаушы күшін  келесі өрнек арқылы анықтаймыз:
        
        және ең ақырғы өрнек келесідей болады:
            (5)
        Джоуль – Ленц заңына сәйкес dt уақыт аралығында R кедергісінде бөлініп шығатын жылу мөлшері     немесе   екендігін ескерсек, онда      .
        Уақыт бойынша интегралдап, келесі өрнекті аламыз:
        
        және ең ақырғы есептеу формуласы 
        `,
        id_faq: "faq_59",
        for_faq: "faq_59",
        question: `Электр қозғаушы күші  тұрақты тоқ көзіне  кедергі және индуктивтілігі   катушка жалғанған. Катушкаға параллеь  R = 3 Ом кедергі жалғанған. Катушкадағы тоқ шамасы тағайындалған мәніне жеткеннен кейін, тоқ көзі К кілтімен ажыратылады. Тізбек ажыратылғаннан кейінгі  R кедергі бойында бөлінетін Q жылу мөлшерін және электр қозғаушы күшінің уақыттық тәуелділігін табыңыз. Тоқ көзі мен жалғағыш сымдардың кедергілерін ескермеңіз.

        `,
        img_url: heroImg,
        answers: `# RL тізбегіндегі экстраток
        import math as mt
        import matplotlib.pyplot as plt
        L=2.0e-3; R0=1.0; R=3.0; E=1.5;
        alpha=(R0+R)/L; tau=1./alpha;
        Es0=E*(1.+R/R0);
        Q=(E/R0)**2*R*L/2./(R0+R);
        print('Es0=',Es0,'\n Q=',Q,'\ntau=',tau)
        NT=500; tmin=0.; tmax=3.*tau; dt=(tmax-tmin)/NT;
        t=[]; Es=[]; Qs=[];
        t.append(tmin/tau);Es.append(E);Qs.append(0.);
        for i in range(1,NT):
            tt=tmin+i*dt; t.append(tt/tau);
            Es.append(Es0*mt.exp(-alpha*tt)/E);
            Qs.append((E/R0)**2*R*mt.exp(-2.*alpha*tt));
        plt.subplot(1,2,1)
        plt.plot(t,Es,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t/tau$',fontsize=16)
        plt.ylabel('$E_s/E$',fontsize=16)
        plt.subplot(1,2,2)
        plt.plot(t,Qs,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t/tau$',fontsize=16)
        plt.ylabel('$Q, Дж$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 59,
        img1: `59-мысал.gif`,
        img2: `Снимок экрана (1185).png`,
    },
    {
        task_id: "60",
        content_title: `Тізбектегі тізбектеліп жалғанған элементтер үшін теңдеу келесі түрде болады:
        (1)

Тізбектелген тізбекте   ,  ескеріп (1) теңдеуді келесі түрде жазамыз:


немесе 

    (2)

Белгілеулер енгізе отырып,   (2)-ші қарапайым кәдімгі екінші дәрежелі дифференциальдық  теңдеу түріне келтіреміз:

  (3)

теңдеудің шешімі жүйедегі параметрлерге байланысты.

Тербелмелі емес ауыспалы процестер үшін:
⦁	 
⦁	

Біздің есебіміздің шартында бірінші жағдай жүзеге асады: бастапқы шарт 



Интегралдау тұрақтысын теңдеулер жүйесінен анықтаймыз



.   (3) - ші теңдеулер жүйесінің шешімі келесідей болады:

(4)

        (5)

`,
        id_faq: "faq_60",
        for_faq: "faq_60",
        question: `Электр қозғаушы күші тұрақты тоқ көзінен сыйымдылығы  конденсатор   индуктивтілік және R кедергі,  , арқылы зарядталады. Конденсатордағы  кернеу мен I тоқ күші уақытқа байланысты қалай өзгеретінін анықтаңыз. Уақыттың  мезетіндегі  кернеуі  мен I тоқ күшін есептеңіз`,
        img_url: heroImg,
        answers: `#Релаксация тока в RLC-цепи
        import math as mt
        import matplotlib.pyplot as plt
        C=0.47e-6; L=2.5e-6; E=12.0; t1=1.e-6;
        R=mt.sqrt(4.*L/C);
        print('R=',R)
        beta=R/(2.*L); tau=1/beta;
        U1=E*(1.-(1+beta*t1)*mt.exp(-beta*t1));
        I1=E*C*beta*beta*t1*mt.exp(-beta*t1);
        print('U1=',U1,'\nI1=',I1,'\ntau=',tau,'\nt1/tau=',t1/tau)
        NT=500; tmin=0; tmax=5.*tau; dt=(tmax-tmin)/NT;
        t=[]; U=[]; I=[];
        t.append(tmin/tau);U.append(0);I.append(0);
        for i in range(1,NT):
            tt=tmin+i*dt; t.append(tt/tau);
            U.append(E*(1.-(1+beta*tt)*mt.exp(-beta*tt)));
            I.append(E*C*beta*beta*tt*mt.exp(-beta*tt));
        plt.subplot(1,2,1)
        plt.plot(t,U,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t/tau$',fontsize=16)
        plt.ylabel('$U_C$',fontsize=16)
        plt.subplot(1,2,2)
        plt.plot(t,I,'k-',linewidth=2.0)
        plt.grid(True)
        plt.xlabel('$t/tau$',fontsize=16)
        plt.ylabel('$I$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 60,
        img1: `60-мысал.gif`,
        img2: `Снимок экрана (1189).png`,
    },
];

const structure = [
    {
        name: `ЭЛЕКТРОМАГНИТТІК ИНДУКЦИЯ ҚҰБЫЛЫСЫ`,
    },
];

const TaskCompEl = () => {

    return (
        <Fragment>
            <Header />
            {/* {structure.map((item) => (
                <Navmenu item={item} />
            ))} */}

            <br /><br /><br />

            <section>
                <Container className="taskmenu">
                    {taskdata.map((item) => (
                        <TaskCard item={item} />
                    ))}
                </Container>
            </section>
            <Sidebar />
            <Footer />
        </Fragment>
    );
};

export default TaskCompEl;
